import './sideNavigation.css';
import 'simplebar/dist/simplebar.css';
import {Control} from 'ol/control';
import {createHTMLElement, sortObjects} from '/src/modules/misc/misc';
import ImageSlider from '/src/modules/imageSlider/imageSlider';
import SimpleBar from 'simplebar/dist/simplebar';
import {exhibitionConfig, lang, map} from '/main';

export class SideNavigationControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const sideNavigation = createHTMLElement('div', 'sideNavigation ol-unselectable', 'overlayMenu');
    sideNavigation.style.height = document.documentElement.clientHeight + 'px';
    sideNavigation.style.maxHeight = document.documentElement.clientHeight + 'px';

    const mainNavigation = createHTMLElement('div', 'main', 'main');
    const sideNavigationHead = createHTMLElement('div', 'head');
    const sideNavigationCloseButton = createHTMLElement('div', 'closeButton', null, '<i class="fas fa-times"></li>');
    const sideNavigationHeadTitle = createHTMLElement('div', 'headTitle', null, (exhibitionConfig['menu'] !== null ? exhibitionConfig['menu']['title'] : lang['sideNavigationDefaultTitle']));
    const sideNavigationImagery = createHTMLElement('div', 'imagery');

    sideNavigationHead.appendChild(sideNavigationCloseButton);
    sideNavigationHead.appendChild(sideNavigationHeadTitle);

    const contentArray = [];

    if (exhibitionConfig['menu']['images'].length > 0) {
      for (let i = 0; i < exhibitionConfig['menu']['images'].length; i++) {
        contentArray.push({
          'type': 'image',
          'url': exhibitionConfig['menu']['images'][i].url,
          'position': exhibitionConfig['menu']['images'][i].position,
        });
      }
    }

    if(contentArray.length > 0) {
      contentArray.sort(function(a, b) {
        return sortObjects(a.position, b.position);
      });
    }

    sideNavigationImagery.appendChild(ImageSlider(contentArray));

    const sideNavigationContent = createHTMLElement('div', 'content', 'sideNavigationContent');

    sideNavigationContent.appendChild(sideNavigationImagery);
    mainNavigation.appendChild(sideNavigationHead);
    mainNavigation.appendChild(sideNavigationContent);
    sideNavigation.appendChild(mainNavigation);
    sideNavigation.appendChild(createSidenavFooter());

    super({
      element: sideNavigation,
      target: options.target,
    });

    window.addEventListener('resize', this.resizeOnWindowChange.bind(this), {passive: true});
    sideNavigationCloseButton.addEventListener('click', this.setTransformStyleToNull.bind(this), {passive: true});
    sideNavigationCloseButton.addEventListener('touchstart', this.setTransformStyleToNull.bind(this), {passive: true});
  }

  resizeOnWindowChange() {
    const sideNavigation = document.getElementById('overlayMenu');
    sideNavigation.style.height = document.documentElement.clientHeight + 'px';
    sideNavigation.style.maxHeight = document.documentElement.clientHeight + 'px';
  }

  setTransformStyleToNull() {
    const sideNavigation = document.getElementById('overlayMenu');
    sideNavigation.style.transform = null;
  }
}

export function createNavigationEntries(entryArray) {
  if (typeof entryArray !== 'undefined' && entryArray.length > 0) {
    let sideNavigation = document.getElementById('overlayMenu');
    let contentContainer = document.getElementById('sideNavigationContent');

    for (let e = 0; e < entryArray.length; e++) {
      let sideNavigationEntry = document.createElement('div');
      let mainNavigation = document.getElementById('main');

      sideNavigationEntry.className = 'entry';

      if (typeof entryArray[e]['icon'] !== 'undefined') {
        if (entryArray[e]['icon']['iconType'] === 'fa') {
          sideNavigationEntry.innerHTML += '<i class="fas ' + entryArray[e]['icon']['iconContent'] + ' faIcon"></i>';
        } else if (entryArray[e]['icon']['iconType'] === 'mi') {
          sideNavigationEntry.innerHTML += '<i class="material-icons miIcon">' + entryArray[e]['icon']['iconContent'] + '</i>';
        }
      }

      if (typeof entryArray[e]['switchable'] !== 'undefined' && typeof entryArray[e]['list'] === 'undefined') {
        let sideNavigationEntryTitle = document.createElement('label');
        sideNavigationEntryTitle.setAttribute('for', entryArray[e]['identifier']);
        sideNavigationEntryTitle.innerHTML = entryArray[e]['title'];

        let switchLabel = document.createElement('label');
        switchLabel.className = 'switch';

        let switchInput = document.createElement('input');
        switchInput.type = 'checkbox';
        switchInput.id = entryArray[e]['identifier'];

        let roundSlider = document.createElement('span');
        roundSlider.classList.add('slider');
        roundSlider.classList.add('round');

        switchLabel.appendChild(switchInput);
        switchLabel.appendChild(roundSlider);

        sideNavigationEntry.addEventListener('click', function() {
          if (switchInput.checked === false) {
            switchInput.checked = true;
            switchLayerVisibility(entryArray[e]['identifier'], true);
          } else {
            switchInput.checked = false;
            switchLayerVisibility(entryArray[e]['identifier'], false);
          }
        }, {passive: true});

        sideNavigationEntry.appendChild(sideNavigationEntryTitle);
        sideNavigationEntry.appendChild(switchLabel);
      } else if (entryArray[e]['list'] === true) {
        let subNavigation = null;

        subNavigation = createSubNavigation(entryArray[e]['subEntries']);

        sideNavigationEntry.innerHTML += '<label for="' + entryArray[e]['identifier'] + 'Sub">' + entryArray[e]['title'] + '</label>';

        let sideNavigationEntryOpenButton = document.createElement('div');
        sideNavigationEntryOpenButton.className = 'openButton';
        sideNavigationEntryOpenButton.id = entryArray[e]['identifier'] + 'Sub';
        sideNavigationEntryOpenButton.innerHTML = '<i class="fas fa-chevron-right"></i>';

        sideNavigationEntry.appendChild(sideNavigationEntryOpenButton);

        sideNavigationEntry.addEventListener('click', () => {
          mainNavigation.style.transform = 'translateX(-360px)';
          subNavigation.style.transform = 'translateX(0px)';

          if (typeof entryArray[e]['autoSwitch'] !== 'undefined') {
            document.getElementById(entryArray[e]['identifier']).checked = true;
            switchLayerVisibility(entryArray[e]['identifier'], true);
          }
        }, {passive: true});

        if (subNavigation !== null) {
          sideNavigation.appendChild(subNavigation);
        }
      }

      contentContainer.style.maxHeight = (document.documentElement.clientHeight - 121) + 'px';
      contentContainer.style.height = (document.documentElement.clientHeight - 121) + 'px';

      window.addEventListener('resize', () => {
        contentContainer.style.maxHeight = (document.documentElement.clientHeight - 121) + 'px';
        contentContainer.style.height = (document.documentElement.clientHeight - 121) + 'px';
      }, {passive: true});

      contentContainer.appendChild(sideNavigationEntry);
    }
    new SimpleBar(contentContainer);
  }
}

function createSubNavigation(menuEntries) {
  let sideNavigation = document.getElementById('main');

  let sideSubNavigation = document.createElement('div');
  sideSubNavigation.className = 'sub';
  sideSubNavigation.id = menuEntries['identifier'] + 'Submenu';

  let subNavigation = document.createElement('div');
  subNavigation.className = 'subNavigation';
  subNavigation.id = menuEntries['identifier'] + 'Menu';
  subNavigation.style.maxHeight = document.documentElement.clientHeight + 'px';
  subNavigation.style.height = document.documentElement.clientHeight + 'px';

  window.addEventListener('resize', () => {
    subNavigation.style.maxHeight = document.documentElement.clientHeight + 'px';
    subNavigation.style.height = document.documentElement.clientHeight + 'px';
  }, {passive: true});

  let subNavigationHead = document.createElement('div');
  subNavigationHead.className = 'head';

  let subNavigationCloseButton = document.createElement('div');
  subNavigationCloseButton.className = 'closeButton';
  subNavigationCloseButton.innerHTML = '<i class="fas fa-chevron-left"></i>';

  subNavigationCloseButton.addEventListener('click', function() {
    sideSubNavigation.style.transform = '';
    sideNavigation.style.transform = '';
  }, {passive: true});

  subNavigationHead.appendChild(subNavigationCloseButton);

  let subNavigationHeadTitle = document.createElement('div');
  subNavigationHeadTitle.className = 'headTitle';
  subNavigationHeadTitle.innerHTML = typeof menuEntries !== 'undefined' ? menuEntries['title'] : '';

  subNavigationHead.appendChild(subNavigationHeadTitle);

  if (typeof menuEntries['switchable'] !== 'undefined') {
    let switchLabel = document.createElement('label');
    switchLabel.className = 'switch';

    let switchInput = document.createElement('input');
    switchInput.type = 'checkbox';
    switchInput.id = menuEntries['identifier'];

    let roundSlider = document.createElement('span');
    roundSlider.classList.add('slider');
    roundSlider.classList.add('round');

    switchLabel.appendChild(switchInput);
    switchLabel.appendChild(roundSlider);

    switchLabel.addEventListener('click', function() {
      if (switchInput.checked === false) {
        switchInput.checked = true;
        switchLayerVisibility(menuEntries['identifier'], true);
      } else {
        switchInput.checked = false;
        switchLayerVisibility(menuEntries['identifier'], false);
      }
    }, {passive: true});

    subNavigationHead.appendChild(switchLabel);
  }

  let subNavigationImagery = document.createElement('div');
  subNavigationImagery.className = 'imagery';

  let contentArray = [];

  let subNavigationContent = document.createElement('div');
  subNavigationContent.className = 'content';
  subNavigationContent.id = menuEntries['identifier'] + 'Content';
  subNavigationContent.style.height = (document.documentElement.clientHeight - 121) + 'px';
  subNavigationContent.style.maxHeight = (document.documentElement.clientHeight - 121) + 'px';

  window.addEventListener('resize', () => {
    subNavigationContent.style.height = (document.documentElement.clientHeight - 121) + 'px';
    subNavigationContent.style.maxHeight = (document.documentElement.clientHeight - 121) + 'px';
  }, {passive: true});

  if ((typeof menuEntries['images'] !== 'undefined' && menuEntries['images'].length > 0) || (typeof menuEntries['videos'] !== 'undefined' && menuEntries['videos'].length > 0)) {
    if (typeof menuEntries['images'] !== 'undefined' && menuEntries['images'].length > 0) {
      for (let i = 0; i < menuEntries['images'].length; i++) {
        contentArray.push({
          'type': 'image',
          'url': menuEntries['images'][i]['url'],
          'position': menuEntries['images'][i]['position'],
        });
      }
    }

    if (typeof menuEntries['videos'] !== 'undefined' && menuEntries['videos'].length > 0) {
      for (let v = 0; v < menuEntries['videos'].length; v++) {
        contentArray.push({
          'type': 'video',
          'url': menuEntries['videos'][v]['url'],
          'position': menuEntries['videos'][v]['position'],
        });
      }
    }

    if (contentArray.length > 0) {
      contentArray.sort(function(a, b) {
        return sortObjects(a.position, b.position);
      });
    }
    subNavigationImagery.appendChild(ImageSlider(contentArray));

    subNavigationContent.appendChild(subNavigationImagery);
  }

  if (typeof menuEntries['description'] !== 'undefined' && (menuEntries['description'].length > 0 || menuEntries['description'] !== null)) {
    let subNavigationDescription = document.createElement('div');
    subNavigationDescription.className = 'description';

    if (menuEntries['description']['header'] !== null) {
      subNavigationDescription.innerHTML = '<p>' + menuEntries['description']['header'] + '</p>';
    }

    if (menuEntries['description']['content'] !== null) {
      subNavigationDescription.innerHTML += '<p>' + menuEntries['description']['content'] + '</p>';
    }

    if (menuEntries['description']['links'].length > 0) {
      for (let link of menuEntries['description']['links']) {
        subNavigationDescription.innerHTML += '<p><a href="' + link['url'] + '" target="_blank">' + link['title'] + '</a></p>';
      }
    }

    subNavigationContent.appendChild(subNavigationDescription);
  }

  if (typeof menuEntries['listEntries'] !== 'undefined' && (menuEntries['listEntries'].length > 0 || menuEntries['listEntries'] !== null)) {
    menuEntries['listEntries'].sort((a, b) => {
      return sortObjects(a.position, b.position);
    });

    for (let listEntry of menuEntries['listEntries']) {
      let entryContainer = document.createElement('div');
      entryContainer.className = 'entry';

      if (typeof listEntry['color'] !== 'undefined' && listEntry['color'] !== null) {
        if (typeof listEntry['icon'] !== 'undefined' && listEntry['icon'] !== null) {
          if (listEntry['icon'] === 'square') {
            let colorCell = document.createElement('div');
            colorCell.className = 'cell';

            let colorBlock = document.createElement('div');
            colorBlock.className = 'colorBlock';

            if (typeof listEntry['color2'] !== 'undefined' && listEntry['color2'] !== null) {
              colorBlock.style.background = 'linear-gradient(' + listEntry['color'] + ', ' + listEntry['color2'] + ')';
            } else {
              colorBlock.style.background = listEntry['color'];
            }

            colorCell.appendChild(colorBlock);

            entryContainer.appendChild(colorCell);
          }
        }
      }

      let titleCell = document.createElement('div');
      titleCell.className = 'cell';

      let entryTitle = document.createElement('label');
      entryTitle.setAttribute('for', listEntry['identifier']);
      entryTitle.innerHTML = listEntry['title'];

      titleCell.appendChild(entryTitle);

      entryContainer.appendChild(titleCell);

      subNavigationContent.appendChild(entryContainer);
    }
  }

  subNavigationContent.setAttribute('data-simplebar', 'init');

  subNavigation.appendChild(subNavigationHead);
  subNavigation.appendChild(subNavigationContent);

  sideSubNavigation.appendChild(subNavigation);

  return sideSubNavigation;
}

function createSidenavFooter() {
  let sideNavigationFooter = document.createElement('div');
  sideNavigationFooter.className = 'footer';
  sideNavigationFooter.innerHTML = '<div class="sideNavigation-divider"></div>';

  let sideNavigationFooterNav = document.createElement('ul');
  sideNavigationFooterNav.className = 'navigation';
  sideNavigationFooterNav.innerHTML = '<li><span class="name">Flayr</span> <i class="material-icons">&#xE53B;</i></li>' +
    '<li><a href="' + exhibitionConfig['menu']['footer']['imprint_de'] + '" target="_blank">' + lang['sideNavigationImprint'] + '</a></li>' +
    '<li><a href="' + exhibitionConfig['menu']['footer']['disclaimer_de'] + '" target="_blank">' + lang['sideNavigationDataPrivacy'] + '</a></li>' +
    '<li><a href="' + exhibitionConfig['menu']['footer']['help_de'] + '" target="_blank">' + lang['sideNavigationHelp'] + '</a></li>';

  sideNavigationFooter.appendChild(sideNavigationFooterNav);

  return sideNavigationFooter;
}

function switchLayerVisibility(identifier, visibility) {
  let layers = map.getLayers();

  layers.forEach(function(layer) {
    if (typeof layer.get('menu') !== 'undefined' && layer.get('menu').identifier === identifier) {
      if (visibility === true) {
        if (layer.getVisible() === false) {
          layer.setVisible(true);
        }
      } else if (visibility === false) {
        if (layer.getVisible() === true) {
          layer.setVisible(false);
        }
      }
    }
  });
}
